import axiosInstance from '../../axios-config';

const followUpPlansApi = '/api/patients/{0}/followUpPlan';
const getFollowUpPlanNotifSettings = 'api/patients/{0}/notificationSettings?type=Followups';

export const getFollowUpPlans = (patientId, showArchived) => {
  if (showArchived !== true) {
    return axiosInstance.get(followUpPlansApi.replace('{0}', patientId));
  }

  return axiosInstance.get(followUpPlansApi.replace('{0}', patientId) + '?includeArchived=true');
};

export const getPatientFollowUpPlanNotifSettings = (patientId) =>
  axiosInstance
    .get(getFollowUpPlanNotifSettings.replace('{0}', patientId))
    .catch((axiosResponse) => {
      const error = axiosResponse.response;
      if (error.status === 404) {
        const data = {
          data: {
            patientSettings: {
              email: false,
              sms: false,
            },
          },
        };
        return Promise.resolve(data);
      }

      return Promise.reject(error);
    });